export default __webpack_public_path__ + "static/media/gallery_03.c53ff7f3.jpg";